// Client-side shape check for a pasted Solana address. The server additionally
// verifies the key is on the ed25519 curve and not a program-derived address.
const BASE58_ADDRESS = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;

export function isSolanaAddress(value: string): boolean {
  return BASE58_ADDRESS.test(value.trim());
}

export function shortenWallet(address: string): string {
  if (address.length <= 8) return address;
  return `${address.slice(0, 4)}…${address.slice(-4)}`;
}
